// extracted by mini-css-extract-plugin
module.exports = {"RV-K":"EU_RV-K__j5mai"};